import { render, staticRenderFns } from "./ProductInfoAccounting.vue?vue&type=template&id=3947c4b7"
import script from "./ProductInfoAccounting.vue?vue&type=script&lang=ts"
export * from "./ProductInfoAccounting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3947c4b7')) {
      api.createRecord('3947c4b7', component.options)
    } else {
      api.reload('3947c4b7', component.options)
    }
    module.hot.accept("./ProductInfoAccounting.vue?vue&type=template&id=3947c4b7", function () {
      api.rerender('3947c4b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductInfoAccounting.vue"
export default component.exports